import { PaletteColorOptions } from '@mui/material';
import { FeatureFlags } from '@procureai/permissions-ui';
import { createContext, useContext } from 'react';

import { defaultConfig } from './ConfigProvider.config';

export type ConfigContextState = {
  palette?: {
    primary?: PaletteColorOptions;
    secondary?: PaletteColorOptions;
  };
  tenant: {
    geo: {
      latitude: number;
      longitude: number;
    };
  };
  map: {
    style: string;
    zoom: number;
  };
  filters: {
    count: number;
  };
  features: FeatureFlags;
  intercom: {
    enabled: boolean;
    appId: string;
    apiBase?: string;
    customerKey: string;
  };
  supportEmail: string;
  fallbackCatalogueSupplierID?: string;
  negotiationFeed: {
    pollInterval?: number;
  };
  demand: {
    parallelNegotiationsMax?: number;
  };
  widgets: {
    strategicSpendThreshold?: number;
  };
  search: {
    defaultSearchModeIsSemantic: boolean;
  };
  languages: string[];
  getMapsUrl: (address: any) => string;
};

const ConfigContext = createContext<ConfigContextState>({ ...defaultConfig, getMapsUrl: () => '' });
export const ConfigContextProvider = ConfigContext.Provider;

export const useConfig = (): ConfigContextState => {
  return useContext(ConfigContext);
};
